


























































































import { Vue, Component, Prop, Provide } from "vue-property-decorator";
import EditPage from "@/components/EditPage";

@Component
export default class TemplatePersPlanung extends EditPage {
  constructor() {
    super();
    this.query = "WebPersPlanungDialog";
  }
}
